import { ViewDetails } from '../../models/view-details.model';
import { RequestsTypesConstants } from '../requests-side-menu.constants';
import { TablePropertiesConstants } from '../table-properties.constant';

export class EmployeeConstants {
    public static ASSIGNED_TO_ME_REQUESTS: ViewDetails = {
        ...RequestsTypesConstants.ASSIGNED_TO_ME_REQUESTS,
        tableColumn: TablePropertiesConstants.TABLE_COLUMNS_WITH_SLA,
        tableWithSelection: false
    };

    public static COMPLETED_REQUESTS: ViewDetails = {
        ...RequestsTypesConstants.COMPLETED_REQUESTS,
        tableColumn: TablePropertiesConstants.TABLE_COLUMNS_WITH_CLOSED_DATE,
        tableWithSelection: false
    };
}
